import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "../../Elements/Dialog";
import { INotification } from "../../types/INotification";
import { formatDate } from "@inceptionbg/ui-components";
import { IInputComponentProps, Input } from "../../Elements/Input";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  notification: INotification;
}

export const NotificationDetailsDialog: FC<Props> = ({
  isOpen,
  onClose,
  notification,
}) => {
  const { t } = useTranslation();

  const notificationInfo: IInputComponentProps[] = [
    {
      label: t("NotificationType"),
      value: t(`NotificationType${notification.type}`),
      readOnly: true,
    },
    {
      label: t("NotificationChannel"),
      value: t(`CommunicationChannel${notification.communicationChannelType}`),
      readOnly: true,
    },
    {
      label: t("NotificationSentDate"),
      value: formatDate(notification.createdAt),
      readOnly: true,
    },
    {
      label: t("NotificationMessage"),
      value: notification.message,
      readOnly: true,
    },
    {
      label: t("RelatedRequest"),
      value: notification.approval?.approvalNumber
        ? notification.approval.approvalNumber.toString()
        : "-",
      readOnly: true,
    },
  ];

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={t("ApprovalUpdate")}
      desc={t("ApprovalUpdateDesc")}
      size="l"
      cancelButton={{
        label: t("Back"),
        onClick: onClose,
      }}
      notMobileFullScreen
    >
      <div className="flex column gap-4">
        {notificationInfo.map((e) => (
          <Input key={e.label} component={e} />
        ))}
      </div>
    </Dialog>
  );
};
